import type { FC } from "react";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";

export const CountDownResendCode: FC<{ backUrl: string }> = ({ backUrl }) => {
  const [seconds, setSeconds] = useState(30);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((seconds) => Math.max(seconds - 1, 0));
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <p className="w-full gap-3 text-center text-[14px] font-semibold leading-[22px]">
      <Trans i18nKey={"webapp.havent_receive_otp"}>
        Haven’t received the code?
      </Trans>
      <br />
      {seconds ? (
        <Trans
          i18nKey={"webapp.resend_code_in"}
          defaults="You can resend the code in {{ seconds }} seconds."
          values={{ seconds }}
        >
          null
        </Trans>
      ) : (
        <a href={backUrl} className="text-link cursor-pointer">
          <Trans i18nKey={"webapp.resend_code_now"}>Resend code.</Trans>
        </a>
      )}
    </p>
  );
};
